import { Box } from '@modusign/design-system';
import cx from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import LocalLoadingSpinner from '@app/components/Loading/LocalLoadingSpinner';
import { getIsFetching } from '@app/store/signingProgressInformation/selectors';

import SignatureInformation from '../SignatureInformation';
import SignatureProgressList from '../SignatureProgressList';

import './SignatureProgressInformationContent.scss';

function SignatureProgressInformationContent() {
  const { t } = useTranslation();
  const [toggle, setToggle] = useState(false);

  const isFetching = useSelector(getIsFetching);

  function handleShowDocInfo() {
    setToggle(false);
  }

  function handleShowProgressList() {
    setToggle(true);
  }

  return isFetching ? (
    <LocalLoadingSpinner />
  ) : (
    <div>
      <ul className="WindowModal__tab-bar SignatureProgressInformationContent__tab-bar">
        <li className="WindowModal__tab-box">
          <button
            className={cx('WindowModal__tab', { 'WindowModal__tab--active': !toggle })}
            type="button"
            onClick={handleShowDocInfo}
          >
            {t('SignatureProgressInformationContent-showDocumentInfoButton')}
          </button>
        </li>
        <li className="WindowModal__tab-box">
          <button
            className={cx('WindowModal__tab', { 'WindowModal__tab--active': toggle })}
            type="button"
            onClick={handleShowProgressList}
          >
            {t('SignatureProgressInformationContent-showProgressListButton')}
          </button>
        </li>
      </ul>
      <Box height={['calc(100vh - 89px)', null, '520px']} overflow="auto" pb={['60px', 0]}>
        {document && (
          <div>
            <SignatureInformation active={!toggle} />
            <SignatureProgressList active={toggle} />
          </div>
        )}
      </Box>
    </div>
  );
}

export default SignatureProgressInformationContent;
